import React from "react";
import upi_icon from "../../assets/upi_1.png";

export const isUpiMethod = (method) =>
  !!method && String(method).toLowerCase().includes("upi");

const PaymentMethodIcon = ({ method, style }) => {
  if (!isUpiMethod(method)) return null;

  return (
    <span style={{ display: "inline-flex", alignItems: "center", whiteSpace: "nowrap" }}>
      <img
        src={upi_icon}
        alt="UPI"
        style={{ height: 10, verticalAlign: "middle", marginLeft: 6, ...style }}
      />
      &nbsp;(UPI)
    </span>
  );
};

export default PaymentMethodIcon;
